import { Story } from "@/components/builder/stories/context";
import { Locale } from "@/i18n/i18n.config";
import ArrayUtils from "@/libs/base/utils/array-utils";
import BuilderUtils from "@/libs/builder/utils/builder-utils";
import { BuilderProvider } from "@/services/builder-provider";
import { GetContentOptions } from "@builder.io/sdk/dist/src/builder.class";

export default class StoriesService {
  private readonly locale: Locale;

  constructor(locale: Locale) {
    this.locale = locale;
  }

  async getGenres(): Promise<string[]> {
    const stories = await BuilderUtils.loadAllEntries((page, storiesPerLoad) =>
      this.getStories({ page, storiesPerLoad, fields: "data.genres" }),
    );

    const genres = stories
      .map((story) => story.data?.genres)
      .flat()
      .map((genre) => genre?.toString().trim())
      .filter((genre) => genre) as string[];
    return ArrayUtils.sortBy(ArrayUtils.distinct(genres));
  }

  async getStory(options: SingleStoryContentOptions): Promise<Story | null> {
    const stories = await this.getStories({ page: 1, storiesPerLoad: 1, ...options });
    return stories.length > 0 ? stories[0] : null;
  }

  async getStories(options: StoryContentOptions): Promise<Story[]> {
    const stories = await BuilderProvider.getBuilder().getAll("stories", this.buildContentOptions(options));
    return stories as Story[];
  }

  private buildContentOptions(options: StoryContentOptions): GetContentOptions {
    return BuilderUtils.createBaseContentOptions(this.locale, {
      userAttributes: {
        locale: this.locale,
      },
      fields: options.fields,
      omit: options.omit,
      // sort: { firstPublished: -1 },
      limit: options.storiesPerLoad,
      offset: (options.page - 1) * options.storiesPerLoad,
      query: options.query,
    });
  }
}

interface SingleStoryContentOptions {
  query?: any;
  fields?: string;
  omit?: string;
}

interface StoryContentOptions extends SingleStoryContentOptions {
  page: number;
  storiesPerLoad: number;
}
